<div class="icon-bg smooth-border d-flex align-items-center justify-content-center">
  <span class="bg-blue fa-rotate-by" [style]="iconContainerStyle">
    <i *ngIf="iconClass" class="text-light fa-xl m-2" [ngClass]="iconClass" aria-hidden="true"></i>
    <img *ngIf="img" alt="icon" [src]="img" />
  </span>
</div>
